import { defineMessages } from 'react-intl';

export default defineMessages({
  estimatedStandardMessage: {
    id: 'useSlaService.estimatedStandardMessage',
    defaultMessage: 'Ships free',
  },
  estimatedStandardMessage7to10Days: {
    id: 'useSlaService.estimatedStandardMessage7to10Days',
    defaultMessage: 'Free delivery',
  },
  estimatedWhiteGloveMessage: {
    id: 'useSlaService.estimatedWhiteGloveMessage',
    defaultMessage: 'Free in-home setup',
  },
});
